import { IPaginatedResponse, IPagination } from '@sdk/contracts';
import { createQueryString } from '@utils';

import { RequestService } from '../request';

import { ICreatePost, IPost, IPostFilters } from './post.contract';

export class PostService extends RequestService {
  constructor(apiUrl: string) {
    super(apiUrl);
  }

  async getPosts(pagination: IPagination, filters: IPostFilters, search?: string) {
    const query = createQueryString({
      search,
      limit: pagination.limit,
      page: pagination.page,
      filters
    });
    return this.fetcher<IPaginatedResponse<IPost>>(`/blog/posts?${query}`);
  }

  async getStudentPosts(pagination: IPagination, topic?: string) {
    const query = createQueryString({
      limit: pagination.limit,
      page: pagination.page,
      filters: {
        topic: topic
      }
    });
    return this.fetcher<IPaginatedResponse<IPost>>(`/blog/posts/student?${query}`);
  }

  async createPost(data: ICreatePost) {
    return this.poster<IPost, ICreatePost>('/blog/posts', data);
  }

  async updatePost(data: Partial<IPost>) {
    return this.putter<IPost, Partial<IPost>>(`/blog/posts/${data._id}`, data);
  }

  async getPost(postId: string) {
    return this.fetcher<IPost>(`/blog/posts/${postId}`);
  }

  async getRelatedPosts(postId: string) {
    return this.fetcher<IPost[]>(`/blog/posts/${postId}/related`);
  }

  async remove(postId: string) {
    return this.deleter(`/blog/posts/${postId}`);
  }

  async publishNow(postId: string) {
    return this.putter<IPost, void>(`/blog/posts/${postId}/publish-now`);
  }

  async getPostsCounts() {
    return this.fetcher<Record<string, number>>('/blog/posts/counts');
  }
}
